$(function () {
  var group = 1;
  var gnum = 18;
  var filternum = $(".content .list .lio").length;
  var filter_v01 = '';

  if (filternum > 0) {
    showPro(group, gnum, $(".content .list .lio").length);
  } else {
    $(".loadbtn").addClass("tip");
  }

  $(".loadbtn .more").click(function () {
    $(this).parent().addClass("on");
    setTimeout(function () {
      group++;
      showPro(group, gnum, $(".content .list .lio").length);
    }, 500);
  });

  $(".category .panel-header .close").click(function() {
    $(".category").removeClass("on");
  })
  $(".btn-class").click(function() {
    $(".category").addClass("on");
  })
  
  colorCheckboxes.on('click', function () {
    filterProducts();
    setTimeout(function () {
      showPro(group, gnum, $(".content .list .lio").length);
    }, 500);
  });
  
  $('form').on('change', function () {
    filterProducts();
    setTimeout(function () {
      showPro(group, gnum, $(".content .list .lio").length);
    }, 500);
  });
  $('form').on('keyup', function () {
    filterProducts();
    setTimeout(function () {
      showPro(group, gnum, $(".content .list .lio").length);
    }, 500);
  });
});

function showPro(a1, a2, a3) {
  $(".content .list .lio").each(function (i) {
    if (i < a1 * a2) {
      $(this).addClass("on");
      if (i >= a3 - 1) {
        $(".loadbtn").addClass("hide");
        return false;
      }
    } else {
      $(".loadbtn").removeClass("on");
      return false;
    }
  });
}

// 获取筛选条件中的文本输入框和颜色复选框
var minPrice = $('#minPrice');
var maxPrice = $('#maxPrice');
var colorCheckboxes = $('input[type="checkbox"]');
// 获取产品列表和筛选结果列表
var productList = $('.content .list');
function filterProducts() {
  var min = parseInt(minPrice.val());
  var max = parseInt(maxPrice.val());
  var colors = [];
  colorCheckboxes.each(function () {
    if ($(this).prop('checked')) {
      colors.push($(this).val());
    }
  });
  productList.find('li').each(function () {
    var price = $(this).find(".price-sale").text().replace(",", "");
    price = parseInt(price.replace("$", ""));
    var color = $(this).find(".available").text();
    if ((isNaN(min) || price >= min) && (isNaN(max) || price <= max) && (colors.length === 0 || colors.includes(color))) {
      $(this).addClass('lio');
    } else {
      $(this).removeClass('lio').removeClass('on');
    }
  });
}
